import { render } from "./ComplianceResultPreview.vue?vue&type=template&id=80a52ca0&scoped=true"
import script from "./ComplianceResultPreview.vue?vue&type=script&lang=js"
export * from "./ComplianceResultPreview.vue?vue&type=script&lang=js"

import "./ComplianceResultPreview.vue?vue&type=style&index=0&id=80a52ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a52ca0"]])

export default __exports__